import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight, Check, GraduationCap, Globe, FlaskConical, BookOpen } from "lucide-react";
import { Kicker, Reveal } from "../motion";
import ParticleField from "../ParticleField";

const HUB = [
  { k: "courses", Icon: GraduationCap },
  { k: "platforms", Icon: Globe },
  { k: "research", Icon: FlaskConical },
  { k: "guides", Icon: BookOpen },
];

export default function HubJoin() {
  const { t } = useTranslation();
  const benefits = t("join.benefits", { returnObjects: true });

  return (
    <>
      <section className="panel-forest py-20 lg:py-28" data-testid="home-hub">
        <ParticleField count={35} />
        <div className="relative max-w-[1500px] mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <Reveal className="lg:col-span-5">
            <Kicker light>{t("home.hub.kicker")}</Kicker>
            <h2 className="font-display text-4xl lg:text-5xl mt-4 leading-[1.05] text-white">{t("home.hub.title")}</h2>
            <p className="mt-5 text-white/75 text-[15px] leading-relaxed max-w-lg">{t("home.hub.body")}</p>
            <Link to="/house-of-wisdom" data-testid="home-hub-cta" className="btn-gold mt-8">
              {t("home.hub.cta")} <ArrowRight className="h-4 w-4 rtl:rotate-180" />
            </Link>
          </Reveal>
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {HUB.map(({ k, Icon }, i) => (
              <Reveal key={k} delay={i * 0.08}>
                <Link to="/house-of-wisdom" className="group flex items-center gap-4 p-5 rounded-xl border border-white/15 bg-white/5 hover:bg-white/10 hover:border-gold-light/60 transition-colors">
                  <span className="h-11 w-11 rounded-lg bg-gold/20 text-gold-light flex items-center justify-center flex-shrink-0 group-hover:bg-gold group-hover:text-white transition-colors">
                    <Icon className="h-5 w-5" />
                  </span>
                  <span className="font-semibold text-white">{t(`knowledge.filters.${k}`)}</span>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="surface-3 py-20 lg:py-24" data-testid="home-join-strip">
        <div className="max-w-[1500px] mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <Reveal className="lg:col-span-7">
            <Kicker>{t("home.join_strip.kicker")}</Kicker>
            <h2 className="font-display text-4xl lg:text-5xl mt-4 leading-[1.05] text-ink">{t("home.join_strip.title")}</h2>
            <p className="mt-4 text-lg text-slate max-w-xl">{t("home.join_strip.body")}</p>
            <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {Array.isArray(benefits) && benefits.map((b, i) => (
                <li key={i} className="flex items-start gap-3 text-sm text-ink/85">
                  <span className="mt-0.5 h-5 w-5 rounded-full bg-forest text-white flex items-center justify-center flex-shrink-0"><Check className="h-3 w-3" /></span>
                  {b}
                </li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-5 lg:text-end">
            <Link to="/join" data-testid="home-join-strip-cta" className="btn-forest !px-8 !py-4">
              {t("home.join_strip.cta")} <ArrowRight className="h-4 w-4 rtl:rotate-180" />
            </Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
